module.exports = __webpack_public_path__ + "assets/images/02_96a5f7aea9259fda800618f980b1e614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial/02.png
// module id = 275
// module chunks = 0